import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.section`
  grid-column: 1 / 4;
`;

export const Title = styled.h5`
  font-weight: 600;
`;

export const Icon = styled.img`
  width: 16px;
  height: 16px;
  margin-right: 8px;
`;

export const IconContainer = styled.div`
  width: 16px;
  height: 16px;
  margin-right: 8px;
`;

export const Luggage = styled.span`
  display: flex;
  align-items: center;
  padding: 16px 0;
  font-size: 12px;
  color: ${({ theme }) => theme.flightSectorBaggage.luggage};

  &.include {
    color: ${({ theme }) => theme.flightSectorBaggage.includeLuggage};
  }
`;

export const Division = styled.hr`
  border: 0 none;
  height: 1px;
  color: ${({ theme }) => theme.flightSectorBaggage.division};
  background-color: ${({ theme }) => theme.flightSectorBaggage.division};
`;

export const Restrictions = styled.p`
  font-size: 12px;
  color: ${ColorPalette.HEX.DimGray2};
`;
